import _regeneratorRuntime from 'babel-runtime/regenerator';

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/logo.png';
import sygnet from '../../assets/img/brand/sygnet.svg';

import { withRouter } from 'react-router-dom';

var logdown = require('logdown');
var console = logdown('rx-dashboard-default-header', { prefixColor: '#009688' });

var propTypes = {
  children: PropTypes.node
};

var defaultProps = {
  logo: logo,
  logoMinimized: sygnet
};

var DefaultHeader = function (_Component) {
  _inherits(DefaultHeader, _Component);

  function DefaultHeader(props) {
    var _this2 = this;

    _classCallCheck(this, DefaultHeader);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.doLogout = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                console.log('in doLogout with ' + _this.props.loginManager);

                _context.prev = 1;
                _context.next = 4;
                return _this.props.loginManager.doLogout();

              case 4:
                console.log('after logout');
                setTimeout(function () {
                  console.log('try to push');
                  _this.props.history.push('/login');
                }, 200);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.log('in error with logout: ' + _context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:

              if (_this.props.logo) {
                _this.props.logo.then(function (data) {

                  console.log('in new data: ', data);
                  _this.setState({ logo: data.default });
                });
              }
              if (_this.props.logoMinimized) {
                _this.props.logoMinimized.then(function (data) {

                  console.log('in new data: ', data);
                  _this.setState({ logoMinimized: data.default });
                });
              }

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    console.log('log props header: ' + JSON.stringify(props), props);
    _this.state = {
      logo: logo,
      logoMinimized: sygnet
    };

    return _this;
  }

  DefaultHeader.prototype.render = function render() {

    // eslint-disable-next-line
    var _props = this.props,
        children = _props.children,
        attributes = _objectWithoutProperties(_props, ['children']);

    return React.createElement(
      React.Fragment,
      null,
      React.createElement(AppSidebarToggler, { className: 'd-lg-none', display: 'md', mobile: true }),
      React.createElement(AppNavbarBrand, {
        full: { src: this.state.logo, width: 150, height: 25, alt: 'rx-dashboard Logo' },
        minimized: { src: this.state.logoMinimized, width: 30, height: 30, alt: 'rx-dashboard Logo' }
      }),
      React.createElement(AppSidebarToggler, { className: 'd-md-down-none', display: 'lg' }),
      React.createElement(
        Nav,
        { className: 'ml-auto', navbar: true },
        React.createElement(
          AppHeaderDropdown,
          { direction: 'down' },
          React.createElement(
            DropdownToggle,
            { nav: true },
            React.createElement('img', { src: 'assets/img/avatar.png', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
          ),
          React.createElement(
            DropdownMenu,
            { right: true, style: { right: 'auto' } },
            React.createElement(
              DropdownItem,
              { onClick: this.doLogout },
              React.createElement('i', { className: 'fa fa-lock' }),
              ' Logout'
            )
          )
        )
      )
    );
  };

  return DefaultHeader;
}(Component);

DefaultHeader.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DefaultHeader.defaultProps = defaultProps;

export default withRouter(DefaultHeader);